<template>
  <div class="material__author">
    <img
      src="../../../assets/images/material-avatar.svg"
      alt="avatar"
    >
    <p>Автор редакции</p>
    <h4>{{ material.authorName || 'Редакция «за школой»' }}</h4>
  </div>
</template>

<script>
export default {
  name: 'MaterialAuthor',
  props: {
    material: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">

.material__author {
  display: grid;
  grid-template-columns: calc(var(--scale) * 44) auto;
  column-gap: calc(var(--scale) * 10);

  img {
    width: calc(var(--scale) * 44);
    grid-row: 1 / 3;
  }

  p {
    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #02120F;

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 16);
    }
  }

  h4 {
    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 12);
    }
  }
}

</style>
